module.exports = "/assets/data/a71b17d39e540828b38500ae31eeaaba-DN1.data.json";